"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
// THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
exports.colors = {
    "all": {
        "coal": "rgb(0, 0, 0)",
        "ink": "rgb(25, 26, 27)",
        "cement": "rgb(101, 101, 102)",
        "fog": "rgb(151, 152, 153)",
        "elephant": "rgb(202, 203, 204)",
        "noise": "rgb(242, 243, 245)",
        "snow": "rgb(255, 255, 255)",
        "silver": "rgb(217, 217, 217)",
        "strawberry": "rgb(250, 222, 221)",
        "code-red": "rgb(238, 7, 0)",
        "mint": "rgb(227, 251, 226)",
        "money-good": "rgb(4, 108, 0)",
        "fuchsia": "rgb(196, 76, 176)",
        "dark-fuchsia": "rgb(180, 60, 160)",
        "teal": "rgb(0, 111, 98)",
        "ivory": "rgb(242, 233, 219)",
        "chatelle": "rgb(213, 194, 216)",
        "edgewater": "rgb(198, 225, 209)",
        "waikawa-gray": "rgb(86, 107, 136)",
        "tuscany": "rgb(186, 83, 44)",
        "klein-blue": "rgb(38, 48, 120)",
        "persian-blue": "rgb(30, 34, 170)",
        "brick": "rgb(158, 48, 57)",
        "goldenrod": "rgb(186, 145, 46)",
        "seafoam": "rgb(177, 191, 170)",
        "coral": "rgb(255, 146, 121)",
        "burnt-orange": "rgb(213, 107, 39)",
        "lilac": "rgb(215, 179, 208)",
        "forest-green": "rgb(0, 55, 40)",
        "cream": "rgb(248, 245, 238)",
        "cornflower-blue": "rgb(127, 154, 207)",
        "moss-green": "rgb(104, 104, 59)",
        "blush": "rgb(243, 222, 217)",
        "canary": "rgb(240, 246, 89)"
    },
    "ui": {
        "strawberry": "rgb(250, 222, 221)",
        "code-red": "rgb(238, 7, 0)",
        "mint": "rgb(227, 251, 226)",
        "money-good": "rgb(4, 108, 0)",
        "fuchsia": "rgb(196, 76, 176)",
        "dark-fuchsia": "rgb(180, 60, 160)",
        "teal": "rgb(0, 111, 98)",
        "ivory": "rgb(242, 233, 219)",
        "chatelle": "rgb(213, 194, 216)",
        "edgewater": "rgb(198, 225, 209)",
        "waikawa-gray": "rgb(86, 107, 136)",
        "tuscany": "rgb(186, 83, 44)"
    },
    "global": {
        "klein-blue": "rgb(38, 48, 120)",
        "persian-blue": "rgb(30, 34, 170)",
        "brick": "rgb(158, 48, 57)",
        "goldenrod": "rgb(186, 145, 46)",
        "seafoam": "rgb(177, 191, 170)",
        "coral": "rgb(255, 146, 121)"
    },
    "mens": {
        "cornflower-blue": "rgb(127, 154, 207)",
        "moss-green": "rgb(104, 104, 59)",
        "blush": "rgb(243, 222, 217)",
        "noise": "rgb(242, 243, 245)",
        "canary": "rgb(240, 246, 89)"
    },
    "womens": {
        "burnt-orange": "rgb(213, 107, 39)",
        "lilac": "rgb(215, 179, 208)",
        "forest-green": "rgb(0, 55, 40)",
        "cream": "rgb(248, 245, 238)",
        "fuchsia": "rgb(196, 76, 176)",
        "dark-fuchsia": "rgb(180, 60, 160)"
    },
    "greyscale": {
        "coal": "rgb(0, 0, 0)",
        "ink": "rgb(25, 26, 27)",
        "cement": "rgb(101, 101, 102)",
        "fog": "rgb(151, 152, 153)",
        "elephant": "rgb(202, 203, 204)",
        "noise": "rgb(242, 243, 245)",
        "snow": "rgb(255, 255, 255)",
        "silver": "rgb(217, 217, 217)"
    }
};
//# sourceMappingURL=colors.js.map